(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  (function () {
    var discountBtn = document.querySelector('[data-mt-discount-btn]');
    if (!discountBtn) return;

    var code = discountBtn.getAttribute('data-mt-discount-code');
    var appliedText = discountBtn.getAttribute('data-mt-discount-applied-texto');

    function markApplied() {
      if (appliedText) discountBtn.textContent = appliedText;
    }

    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var applied = (cart.discount_codes || []).some(function (d) {
          return d.code && d.code.toUpperCase() === code.toUpperCase();
        });
        if (applied) markApplied();
      })
      .catch(function () {});

    discountBtn.addEventListener('click', function () {
      if (navigator.clipboard) {
        navigator.clipboard.writeText(code).catch(function () {});
      }
      markApplied();
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ discount: code })
      }).catch(function () {});
    });
  })();

  (function () {
    var bar = document.querySelector('[data-mt-home-sticky]');
    if (!bar) return;
    var onScroll = function () {
      if (window.scrollY > 420) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  })();

  (function () {
    var PREV_KIT_KEY = 'mt_upsell_previous_variant_id';

    function drawerInner() {
      return document.querySelector('cart-drawer .drawer__inner');
    }

    function refreshCartIcon() {
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var bubble = document.querySelector('.cart-count-bubble');
          var icon = document.getElementById('cart-icon-bubble');
          if (!icon) return;
          if (cart.item_count > 0) {
            if (bubble) {
              var span = bubble.querySelector('span[aria-hidden]');
              if (span) span.textContent = cart.item_count;
            }
          }
        })
        .catch(function () {});
    }

    function replaceDrawerWith(sections) {
      var html = sections && sections['cart-drawer'];
      if (!html) return;
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newInner = doc.querySelector('.drawer__inner');
      var liveInner = drawerInner();
      if (newInner && liveInner) {
        liveInner.innerHTML = newInner.innerHTML;
      }
    }

    function syncRevertLink() {
      var box = document.querySelector('[data-mt-cart-revert]');
      if (!box) return;
      var prevId = localStorage.getItem(PREV_KIT_KEY);
      if (!prevId) {
        box.classList.remove('is-visible');
        return;
      }
      fetch('/cart.js', { cache: 'no-store' })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          if (cart.item_count === 0) {
            localStorage.removeItem(PREV_KIT_KEY);
            box.classList.remove('is-visible');
            return;
          }
          var currentId = cart.items.length === 1 ? String(cart.items[0].variant_id) : null;
          if (currentId && currentId !== prevId) {
            box.classList.add('is-visible');
          } else {
            box.classList.remove('is-visible');
          }
        })
        .catch(function () {});
    }

    var drawerObserver = new MutationObserver(function () {
      syncRevertLink();
    });
    var observedInner = drawerInner();
    if (observedInner) {
      drawerObserver.observe(observedInner, { childList: true, subtree: true });
    }
    syncRevertLink();

    document.addEventListener('click', function (event) {
      var revertLink = event.target.closest('[data-mt-revert-link]');
      if (revertLink) {
        event.preventDefault();
        var prevId = localStorage.getItem(PREV_KIT_KEY);
        if (!prevId) return;
        localStorage.removeItem(PREV_KIT_KEY);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: 1, quantity: 0 }),
        })
          .then(function () {
            return fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ items: [{ id: prevId, quantity: 1 }] }),
            });
          })
          .then(function () {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ sections: 'cart-drawer' }),
            });
          })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            replaceDrawerWith(data.sections);
            refreshCartIcon();
          })
          .catch(function () {});
        return;
      }

      var btn = event.target.closest('[data-mt-upsell-swap]');
      if (!btn) return;
      event.preventDefault();
      if (btn.disabled) return;
      btn.disabled = true;
      var originalText = btn.textContent;
      btn.textContent = '...';
      var newVariantId = btn.getAttribute('data-mt-new-variant-id');
      var oldVariantId = btn.getAttribute('data-mt-old-variant-id');

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: 1, quantity: 0 }),
      })
        .then(function () {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: newVariantId, quantity: 1 }] }),
          });
        })
        .then(function () {
          if (oldVariantId) localStorage.setItem(PREV_KIT_KEY, oldVariantId);
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ sections: 'cart-drawer' }),
          });
        })
        .then(function (r) {
          return r.json();
        })
        .then(function (data) {
          replaceDrawerWith(data.sections);
          refreshCartIcon();
        })
        .catch(function () {
          btn.disabled = false;
          btn.textContent = originalText;
        });
    });
  })();

  (function () {
    var links = document.querySelectorAll(
      '.mt-header-nav-list a[href^="#"], .mt-header-cta[href^="#"], .mt-footer-columna a[href^="#"]'
    );
    links.forEach(function (link) {
      var id = link.getAttribute('href').slice(1);
      if (id && !document.getElementById(id)) {
        link.setAttribute('href', '/#' + id);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-prelander-emergencia"]) return;
  try {
    
  document.querySelectorAll('.mte').forEach(function (root) {
    var bar = root.querySelector('[data-mte-progress]');
    var sticky = root.querySelector('[data-mte-sticky]');
    var umbralParsed = sticky ? parseInt(sticky.getAttribute('data-umbral'), 10) : NaN;
    var umbral = isNaN(umbralParsed) ? 3 : umbralParsed;

    function onScroll() {
      var doc = document.documentElement;
      var max = doc.scrollHeight - doc.clientHeight;
      var pct = max > 0 ? (window.scrollY / max) * 100 : 0;
      if (bar) bar.style.width = Math.min(100, Math.max(0, pct)) + '%';
      if (sticky) {
        if (pct >= umbral) { sticky.classList.add('is-visible'); }
        else { sticky.classList.remove('is-visible'); }
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    onScroll();

    var counter = root.querySelector('[data-mte-counter]');
    if (counter && 'IntersectionObserver' in window) {
      var target = parseInt(counter.getAttribute('data-target'), 10) || 0;
      var prefix = counter.getAttribute('data-prefix') || '';
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      var runCount = function () {
        counter.classList.add('is-visible');
        if (reduceMotion) {
          counter.textContent = prefix + target.toLocaleString('es-ES');
          return;
        }
        var duration = 1800;
        var start = null;
        var step = function (ts) {
          if (!start) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          counter.textContent = prefix + Math.floor(eased * target).toLocaleString('es-ES');
          if (progress < 1) { requestAnimationFrame(step); }
        };
        requestAnimationFrame(step);
      };

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            runCount();
            observer.unobserve(counter);
          }
        });
      }, { threshold: 0.4 });
      observer.observe(counter);
    }

    var noDownload = root.querySelector('[data-mte-no-download]');
    if (noDownload) {
      noDownload.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      noDownload.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mt-sticky-cta"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-mt-sticky-cta]').forEach(function (bar) {
    var umbral = parseInt(bar.getAttribute('data-umbral'), 10) || 500;
    var onScroll = function () {
      if (window.scrollY > umbral) {
        bar.classList.add('is-visible');
      } else {
        bar.classList.remove('is-visible');
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mtpe-producto-hero"]) return;
  try {
    
  document.querySelectorAll('.mtpe').forEach(function (root) {
    var mainImg = root.querySelector('[data-mtpe-galeria-principal] img');
    root.querySelectorAll('[data-mtpe-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        if (!mainImg) return;
        mainImg.src = thumb.getAttribute('data-mtpe-imagen-grande');
        root.querySelectorAll('[data-mtpe-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
      });
    });

    var variantesJson = root.querySelector('[data-mtpe-variantes-json]');
    if (variantesJson) {
      var variantes = JSON.parse(variantesJson.textContent);
      var input = root.querySelector('[data-mtpe-input-id]');
      var selects = root.querySelectorAll('[data-mtpe-opcion]');
      var onChange = function () {
        var elegidas = Array.prototype.map.call(selects, function (sel) { return sel.value; });
        var match = variantes.find(function (v) {
          return v.opciones.every(function (op, i) { return op === elegidas[i]; });
        });
        if (match && input) input.value = match.id;
      };
      selects.forEach(function (sel) { sel.addEventListener('change', onChange); });
    }

    var noDownload = root.querySelector('[data-mtpe-no-download]');
    if (noDownload) {
      noDownload.addEventListener('contextmenu', function (e) { e.preventDefault(); });
      noDownload.addEventListener('dragstart', function (e) { e.preventDefault(); });
    }
  });

  } catch(e) { console.error(e); }
})();
})();
